import Unsupported from './Unsupported';

export default Unsupported;



// WEBPACK FOOTER //
// ./src/components/Unsupported/index.js